export var SpaceMemberRole;
(function (SpaceMemberRole) {
    SpaceMemberRole["VIEWER"] = "viewer";
    SpaceMemberRole["EDITOR"] = "editor";
    SpaceMemberRole["ADMIN"] = "admin";
})(SpaceMemberRole || (SpaceMemberRole = {}));
//# sourceMappingURL=space.js.map